// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

/* global Office */

export function normalizeEmail(email: string | undefined | null): string {
  return (email ?? "").trim().toLowerCase();
}

export function getDistinctEmailAddresses(addresses: Office.EmailAddressDetails[]): Office.EmailAddressDetails[] {
  const distinctAddresses = new Map<string, Office.EmailAddressDetails>();
  addresses
    .filter((a) => normalizeEmail(a?.emailAddress))
    .forEach((a) => {
      const email = normalizeEmail(a.emailAddress);
      if (!distinctAddresses.has(email)) {
        distinctAddresses.set(email, a);
      }
    });
  return [...distinctAddresses.values()];
}

export function getMailboxItemEmailAddresses(item: Office.MessageRead): Office.EmailAddressDetails[] {
  return getDistinctEmailAddresses([item.from, ...(item.to ?? []), ...(item.cc ?? [])]);
}

export function distinctById<T extends { id: string }>(items: T[]): T[] {
  const distinctItems = new Map<string, T>();
  items.forEach((i) => {
    if (!distinctItems.has(i.id)) {
      distinctItems.set(i.id, i);
    }
  });
  return [...distinctItems.values()];
}

export function excludeEmailAddresses(
  addresses: Office.EmailAddressDetails[],
  excludedEmails: (string | undefined | null)[]
): Office.EmailAddressDetails[] {
  const normalizedExcludedEmails = excludedEmails.map(normalizeEmail);
  return addresses
    .filter((a) => !normalizedExcludedEmails.includes(normalizeEmail(a.emailAddress)))
    .sort((a, b) => (a.displayName ?? "").localeCompare(b.displayName ?? ""));
}
